(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.reducerToolkit = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createReducer = createReducer;

  class ReducerError extends Error {
    constructor(...params) {
      super(params);

      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, ReducerError);
      }
    }

  }

  function createReducer(initialState, caseMap) {
    return (state = initialState, action) => {
      try {
        const shouldHandleAction = {}.hasOwnProperty.call(caseMap, action.type);
        return shouldHandleAction ? caseMap[action.type](state, action) : state;
      } catch (error) {
        throw new ReducerError(`ReducerError: "${error.message}" caused by "${action.type}"`);
      }
    };
  }
});